import { cssModule, isNil, isNumber, mergeClasses, useAutoFocus, useEventCallback, useMergedRefs } from "../../shared";
export function useInput({
  active,
  autoFocus,
  cssModule: module,
  disabled,
  fluid,
  focus,
  forwardedRef,
  hover,
  id,
  loading,
  onChange,
  placeholder,
  readOnly,
  required,
  type,
  validationState,
  value
}) {
  const inputRef = useMergedRefs(forwardedRef);
  const handleChange = useEventCallback(event => {
    if (!isNil(onChange)) {
      onChange(event);
    }
  });
  useAutoFocus(inputRef, {
    delay: isNumber(autoFocus) ? autoFocus : undefined,
    isDisabled: !autoFocus || disabled || readOnly
  });
  return {
    inputProps: {
      "aria-invalid": validationState === "invalid" ? true : undefined,
      "aria-required": required ? true : undefined,
      disabled,
      id,
      onChange: handleChange,
      placeholder,
      readOnly,
      ref: inputRef,
      type,
      value: value !== null && value !== void 0 ? value : ""
    },
    inputRef,
    wrapperProps: {
      className: mergeClasses(module, cssModule("o-ui-input", // TODO: remove once CSS perf improvement has been merged
      "outline", validationState, fluid && "fluid", loading && "loading", active && "active", focus && "focus", hover && "hover")),
      role: "presentation"
    }
  };
}